import { useState, useEffect } from 'react';

const useCookies = () => {
    const [cookies, setCookies] = useState({});

    const setCookie = (name, value, days) => {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + days);
        document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()}`;
        setCookies({ ...cookies, [name]: value });
      
        // Automatically delete the cookie after the specified time
        const expirationTime = expirationDate.getTime() - Date.now(); // Calculate the remaining time in milliseconds
        setTimeout(() => {
          deleteCookie(name);
        }, expirationTime);
      };

    const getCookie = (name) => {
        const cookie = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return cookie ? cookie.pop() : '';
    };

    const deleteCookie = (name) => {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        const { [name]: deletedCookie, ...restCookies } = cookies;
        setCookies(restCookies);
    };

    useEffect(() => {
        const allCookies = document.cookie
            .split(';')
            .map((cookie) => cookie.split('='))
            .reduce((accumulator, [name, value]) => ({ ...accumulator, [name.trim()]: value }), {});
        setCookies(allCookies);
    }, []);

    return {
        cookies,
        setCookie,
        getCookie,
        deleteCookie,
    };
};

export default useCookies;
